import Vue from 'vue';
import VueRouter from 'vue-router';
import $auth from '@/services/auth'; // eslint-disable-line import/no-cycle
import Home from './views/Home';
import MediaCategoryList from './views/mediacategory/MediaCategoryList';
import MediaCategoryDetail from './views/mediacategory/MediaCategoryDetail';
import MediaCategoryEditor from './views/mediacategory/MediaCategoryEditor';
import StickerList from './views/sticker/StickerList';
import StickerDetail from './views/sticker/StickerDetail';
import StickerEditor from './views/sticker/StickerEditor';
import ThemeList from './views/theme/ThemeList';
import ThemeDetail from './views/theme/ThemeDetail';
import ThemeEditor from './views/theme/ThemeEditor';
import DeviceCategoryList from './views/devicecategory/DeviceCategoryList';
import DeviceCategoryDetail from './views/devicecategory/DeviceCategoryDetail';
import DeviceCategoryEditor from './views/devicecategory/DeviceCategoryEditor';
import ManufacturerList from './views/manufacturer/ManufacturerList';
import ManufacturerDetail from './views/manufacturer/ManufacturerDetail';
import ManufacturerEditor from './views/manufacturer/ManufacturerEditor';
import DeviceList from './views/device/DeviceList';
import DeviceDetail from './views/device/DeviceDetail';
import DeviceEditor from './views/device/DeviceEditor';
import TemplateList from './views/template/TemplateList';
import TemplateDetail from './views/template/TemplateDetail';
import TemplateEditor from './views/template/TemplateEditor';
import TemplateBulkImport from './views/template/TemplateBulkImport';
import TemplateTypeList from './views/templatetype/TemplateTypeList';
import TemplateTypeEditor from './views/templatetype/TemplateTypeEditor';
import ScreenProtectorTypeList from './views/screenprotectortype/ScreenProtectorTypeList';
import ScreenProtectorTypeDetail from './views/screenprotectortype/ScreenProtectorTypeDetail';
import ScreenProtectorTypeEditor from './views/screenprotectortype/ScreenProtectorTypeEditor';
import CountryList from './views/country/CountryList';
import CountryDetail from './views/country/CountryDetail';
import CountryEditor from './views/country/CountryEditor';
import FilmTypeList from './views/filmtype/FilmTypeList';
import FilmTypeDetail from './views/filmtype/FilmTypeDetail';
import FilmTypeEditor from './views/filmtype/FilmTypeEditor';
import FilmtypeCategoryList from './views/filmtypecategory/FilmtypeCategoryList';
import FilmtypeCategoryEditor from './views/filmtypecategory/FilmtypeCategoryEditor';
import StoreCredits from './views/storecredits/StoreCredits';
import FilmCodes from './views/filmcodes/FilmCodes';
import FSCodes from './views/fscodes/FSCodes';
import MachineControl from './views/machinecontrol/MachineControl';
import Translation from './views/translation/Translation';
import TemplateTools from './views/templatetools/TemplateTools';
import TemplateLog from './views/templatetools/TemplateLog';
import DeviceSettingsTab from './views/device/DeviceSettingsTab';
import DeviceTemplatesTab from './views/device/DeviceTemplatesTab';
import MediaCategoryProfileTab from './views/mediacategory/MediaCategoryProfileTab';
import MediaCategoryThemesTab from './views/mediacategory/MediaCategoryThemesTab';
import MediaCategoryStickersTab from './views/mediacategory/MediaCategoryStickersTab';
import ManufacturerProfileTab from './views/manufacturer/ManufacturerProfileTab';
import ManufacturerDevicesTab from './views/manufacturer/ManufacturerDevicesTab';
import Labels from './views/labels/Labels';
import Languages from './views/labels/Languages';
import CustomerList from './views/customers/CustomerList';
import AccessList from './views/access/AccessList';
import AdminAlerts from './views/adminalerts/AdminAlerts';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/mediacategory',
    name: 'mediacategory-list',
    component: MediaCategoryList,
    meta: {
      displayName: 'Media Categories',
      accessControl: 'media',
    },
  },
  {
    path: '/mediacategory/editor',
    name: 'mediacategory-editor',
    component: MediaCategoryEditor,
    meta: {
      accessControl: 'media',
    },
  },
  {
    path: '/mediacategory/:id',
    name: 'mediacategory-detail',
    component: MediaCategoryDetail,
    meta: {
      accessControl: 'media',
    },
    redirect: {
      name: 'mediacategory-profile-tab',
    },
    children: [
      {
        path: '',
        name: 'mediacategory-profile-tab',
        component: MediaCategoryProfileTab,
      },
      {
        path: 'stickers',
        name: 'mediacategory-stickers-tab',
        component: MediaCategoryStickersTab,
      },
      {
        path: 'themes',
        name: 'mediacategory-themes-tab',
        component: MediaCategoryThemesTab,
      },
    ],
  },
  {
    path: '/sticker',
    name: 'sticker-list',
    component: StickerList,
    meta: {
      displayName: 'Stickers',
      accessControl: 'media',
    },
  },
  {
    path: '/sticker/editor',
    name: 'sticker-editor',
    component: StickerEditor,
    meta: {
      accessControl: 'media',
    },
  },
  {
    path: '/sticker/:id',
    name: 'sticker-detail',
    component: StickerDetail,
    meta: {
      accessControl: 'media',
    },
  },
  {
    path: '/theme',
    name: 'theme-list',
    component: ThemeList,
    meta: {
      displayName: 'Themes',
      accessControl: 'media',
    },
  },
  {
    path: '/theme/editor',
    name: 'theme-editor',
    component: ThemeEditor,
    meta: {
      accessControl: 'media',
    },
  },
  {
    path: '/theme/:id',
    name: 'theme-detail',
    component: ThemeDetail,
    meta: {
      accessControl: 'media',
    },
  },
  {
    path: '/devicecategory',
    name: 'devicecategory-list',
    component: DeviceCategoryList,
    meta: {
      displayName: 'Device Categories',
      accessControl: 'device_categories',
    },
  },
  {
    path: '/devicecategory/editor',
    name: 'devicecategory-editor',
    component: DeviceCategoryEditor,
    meta: {
      accessControl: 'device_categories',
    },
  },
  {
    path: '/devicecategory/:id',
    name: 'devicecategory-detail',
    component: DeviceCategoryDetail,
    meta: {
      accessControl: 'device_categories',
    },
  },
  {
    path: '/manufacturer',
    name: 'manufacturer-list',
    component: ManufacturerList,
    meta: {
      displayName: 'Manufacturers',
      accessControl: 'templates',
    },
  },
  {
    path: '/manufacturer/editor',
    name: 'manufacturer-editor',
    component: ManufacturerEditor,
    meta: {
      accessControl: 'templates',
    },
  },
  {
    path: '/manufacturer/:id',
    name: 'manufacturer-detail',
    component: ManufacturerDetail,
    meta: {
      accessControl: 'templates',
    },
    redirect: {
      name: 'manufacturer-profile-tab',
    },
    children: [
      {
        path: '',
        name: 'manufacturer-profile-tab',
        component: ManufacturerProfileTab,
      },
      {
        path: 'devices',
        name: 'manufacturer-devices-tab',
        component: ManufacturerDevicesTab,
      },
    ],
  },
  {
    path: '/device',
    name: 'device-list',
    component: DeviceList,
    meta: {
      displayName: 'Devices',
      accessControl: 'templates',
    },
  },
  {
    path: '/device/editor',
    name: 'device-editor',
    component: DeviceEditor,
    meta: {
      accessControl: 'templates',
    },
  },
  {
    path: '/device/:id',
    name: 'device-detail',
    component: DeviceDetail,
    meta: {
      accessControl: 'templates',
    },
    redirect: {
      name: 'device-settings-tab',
    },
    children: [
      {
        path: '',
        name: 'device-settings-tab',
        component: DeviceSettingsTab,
      },
      {
        path: 'templates',
        name: 'device-templates-tab',
        component: DeviceTemplatesTab,
      },
    ],
  },
  {
    path: '/template',
    name: 'template-list',
    component: TemplateList,
    meta: {
      displayName: 'Templates',
      accessControl: 'templates',
    },
  },
  {
    path: '/template/editor',
    name: 'template-editor',
    component: TemplateEditor,
    meta: {
      accessControl: 'templates',
    },
  },
  {
    path: '/template/bulkimport',
    name: 'template-bulk-import',
    component: TemplateBulkImport,
    meta: {
      accessControl: 'templates',
    },
  },
  {
    path: '/template/:id',
    name: 'template-detail',
    component: TemplateDetail,
    meta: {
      accessControl: 'templates',
    },
  },
  {
    path: '/templatetypes',
    name: 'templatetype-list',
    component: TemplateTypeList,
    meta: {
      displayName: 'Template Types',
      accessControl: 'templates',
    },
  },
  {
    path: '/templatetypes/editor',
    name: 'templatetype-editor',
    component: TemplateTypeEditor,
    meta: {
      accessControl: 'templates',
    },
  },
  {
    path: '/screenprotectortype',
    name: 'screenprotectortype-list',
    component: ScreenProtectorTypeList,
    meta: {
      displayName: 'Screen Protector Types',
      accessControl: 'screen_protector_types',
    },
  },
  {
    path: '/screenprotectortype/editor',
    name: 'screenprotectortype-editor',
    component: ScreenProtectorTypeEditor,
    meta: {
      accessControl: 'screen_protector_types',
    },
  },
  {
    path: '/screenprotectortype/:id',
    name: 'screenprotectortype-detail',
    component: ScreenProtectorTypeDetail,
    meta: {
      accessControl: 'screen_protector_types',
    },
  },
  {
    path: '/country',
    name: 'country-list',
    component: CountryList,
    meta: {
      displayName: 'Country Settings',
      accessControl: 'country_settings',
    },
  },
  {
    path: '/country/editor',
    name: 'country-editor',
    component: CountryEditor,
    meta: {
      accessControl: 'country_settings',
    },
  },
  {
    path: '/country/:id',
    name: 'country-detail',
    component: CountryDetail,
    meta: {
      accessControl: 'country_settings',
    },
  },
  {
    path: '/filmtype',
    name: 'filmtype-list',
    component: FilmTypeList,
    meta: {
      displayName: 'Film Types',
      accessControl: 'film_types',
    },
  },
  {
    path: '/filmtype/editor',
    name: 'filmtype-editor',
    component: FilmTypeEditor,
    meta: {
      accessControl: 'film_types',
    },
  },
  {
    path: '/filmtype/:id',
    name: 'filmtype-detail',
    component: FilmTypeDetail,
    meta: {
      accessControl: 'film_types',
    },
  },
  {
    path: '/filmtypecategory',
    name: 'filmtypecategory-list',
    component: FilmtypeCategoryList,
    meta: {
      displayName: 'Film Type Categories',
      accessControl: 'film_types',
    },
  },
  {
    path: '/filmtypecategory/editor',
    name: 'filmtypecategory-editor',
    component: FilmtypeCategoryEditor,
    meta: {
      accessControl: 'film_types',
    },
  },
  {
    path: '/storecredits',
    name: 'storecredits',
    component: StoreCredits,
    meta: {
      displayName: 'Store Credits',
      accessControl: 'store_credits',
    },
  },
  {
    path: '/filmcodes',
    name: 'filmcodes',
    component: FilmCodes,
    meta: {
      displayName: 'Film Codes',
      accessControl: 'film_codes',
    },
  },
  {
    path: '/fscodes',
    name: 'fscodes',
    component: FSCodes,
    meta: {
      displayName: 'Four Seasons Codes',
      accessControl: 'fs_credits',
    },
  },
  {
    path: '/machinecontrol',
    name: 'machinecontrol',
    component: MachineControl,
    meta: {
      displayName: 'Machine Control',
      accessControl: 'machine_control',
    },
  },
  {
    path: '/translation',
    name: 'translation',
    component: Translation,
    meta: {
      displayName: 'Translation Manager',
      accessControl: 'translation',
    },
  },
  {
    path: '/templatetools',
    name: 'templatetools',
    component: TemplateTools,
    meta: {
      displayName: 'Template Tools',
      accessControl: 'template_tools',
    },
  },
  {
    path: '/templatelog',
    name: 'templatelog',
    component: TemplateLog,
    meta: {
      displayName: 'Template Change Log',
      accessControl: 'template_log',
    },
  },
  {
    path: '/labels',
    name: 'labels',
    component: Labels,
    meta: {
      displayName: 'Labels',
      accessControl: 'developer_tools',
    },
  },
  {
    path: '/languages',
    name: 'languages',
    component: Languages,
    meta: {
      displayName: 'Languages',
      accessControl: 'developer_tools',
    },
  },
  {
    path: '/customers',
    name: 'customerlist',
    component: CustomerList,
    meta: {
      displayName: 'Customer List',
      accessControl: 'customer_list',
    },
  },
  {
    path: '/access',
    name: 'accesslist',
    component: AccessList,
    meta: {
      displayName: 'Internal User Access List',
      accessControl: 'internal_user_list',
    },
  },
  {
    path: '/adminalerts',
    name: 'adminalerts',
    component: AdminAlerts,
    meta: {
      displayName: 'Admin Alerts',
      accessControl: 'internal_user_list',
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  $auth.authenticate().then(() => {
    if (to.meta && to.meta.accessControl) {
      if ($auth.user.permissions.includes(to.meta.accessControl)) {
        next();
      } else {
        next(new Error("You don't have permission to access this route"));
      }
    } else {
      next();
    }
  });
});

export default router;
